export const DropdownArrow = `<svg title="DropdownArrow" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="Dropdown arrow">
<path id="fill" d="M16.2773 9C16.6764 9 17 9.32356 17 9.72268C17 9.90121 16.9339 10.0734 16.8145 10.2061L12.8345 14.6284C12.6216 14.8649 12.3183 15 12 15C11.6817 15 11.3784 14.8649 11.1655 14.6284L7.18552 10.2061C7.06608 10.0734 7 9.90121 7 9.72268C7 9.32356 7.32356 9 7.72268 9H16.2773Z" fill="currentColor"/>
</g>
</svg>
`;